import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '@composite/evidence/dictionary-evidence';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { DictHoliday } from '@models';
import {
  EntityName,
  EvidenceApiUrl,
  ExportTags,
  HistoryEntityType,
} from '@enums';
import { useColumns } from './dict-holiday-columns';
import { Fields } from './dict-holiday-fields';
import { useValidationSchema } from './dict-holiday-schema';

export function DictHolidays() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();

  const evidence = useDictionaryEvidence<DictHoliday>({
    version: 3,
    identifier: 'HOLIDAYS',
    apiProps: {
      url: EvidenceApiUrl.DICT_HOLIDAYS,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.HOLIDAY,
      }),
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'ES__DICT_HOLIDAYS__TABLE__TITLE',
        defaultMessage: 'Svátky',
      }),
      reportTag: ExportTags.DICT_HOLIDAYS,
      defaultSorts: [
        { field: 'date', datakey: 'date', order: 'ASC', type: 'FIELD' },
      ],
    },
    detailProps: {
      entityName: EntityName.HOLIDAY,
      validationSchema,
      GeneralFieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DICT_HOLIDAYS__DETAIL__TITLE',
          defaultMessage: 'Svátek',
        }),
      },
    },
  });

  return <Evidence {...evidence} />;
}
